import React from 'react';

import FlightSearch from '../../components/Flights/FlightSearch';

export default function Flights() {
  return (
    <section className="no-gutters" id="flights">
      <FlightSearch />
    </section>
  );
}



// WEBPACK FOOTER //
// ./src/screens/Places/Flights.jsx